import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PortalHome } from './PortalHome';
import { EventsPage } from './pages/EventsPage';
import { StateDirectoryPage } from './pages/StateDirectoryPage';
import { TenantPublicProfile } from './pages/TenantPublicProfile';
import { SearchResultsPage } from './pages/SearchResultsPage';
import { CategoryDirectoryPage } from './pages/CategoryDirectoryPage';
import { RegionDirectoryPage } from './pages/RegionDirectoryPage';
import { BusinessRegistrationPage } from './pages/BusinessRegistrationPage';
import { SocialProfilePublicPage } from './pages/SocialProfilePublicPage';
import { SocialExplorePage } from './pages/SocialExplorePage';
import { MarketplacePage } from './pages/MarketplacePage';
import { ClaimProfilePage } from './pages/ClaimProfilePage';
import { PricingPage } from '../billing/PricingPage';

// Tournament Module
import TournamentsListPage from '../tournament/pages/TournamentsListPage';
import TournamentDetailPage from '../tournament/pages/TournamentDetailPage';
import StageDetailPage from '../tournament/pages/StageDetailPage';

// Social Bridge
import InstagramCallbackPage from '@/pages/InstagramCallbackPage';

// Wikipesca Module
import { WikiRouter } from '../wikipesca/WikiRouter';

export const DirectoryRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<PortalHome />} />
      <Route path="/estados" element={<PortalHome />} />
      <Route path="/estados/:state" element={<StateDirectoryPage />} />
      <Route path="/empresas/:slug" element={<TenantPublicProfile />} />
      <Route path="/buscar" element={<SearchResultsPage />} />
      <Route path="/search" element={<Navigate to="/buscar" replace />} />
      <Route path="/eventos" element={<EventsPage />} />
      <Route path="/invite/:token" element={<ClaimProfilePage />} />
      <Route path="/planos" element={<PricingPage />} />
      {/* TODO: Adicionar outras rotas */}
      {/* Categorias */}
      <Route path="/pousadas" element={<CategoryDirectoryPage />} />
      <Route path="/hoteis" element={<CategoryDirectoryPage />} />
      <Route path="/barcos-hoteis" element={<CategoryDirectoryPage />} />
      <Route path="/guias" element={<CategoryDirectoryPage />} />
      <Route path="/agencias" element={<CategoryDirectoryPage />} />
      <Route path="/influenciadores" element={<CategoryDirectoryPage />} />
      <Route path="/associacoes" element={<CategoryDirectoryPage />} />
      <Route path="/pesqueiros" element={<CategoryDirectoryPage />} />
      <Route path="/turmas" element={<CategoryDirectoryPage />} />
      
      {/* Regiões */}
      <Route path="/regiao/:region" element={<RegionDirectoryPage />} />

      {/* Cidades (Placeholder) */}
      <Route path="/cidade/:city" element={<CategoryDirectoryPage />} /> {/* Usando Category como fallback por enquanto */}

      {/* Página de Cadastro de Empresas */}
      <Route path="/cadastrar-empresa" element={<BusinessRegistrationPage />} />

      {/* Ecossistema Social */}
      <Route path="/explorar" element={<SocialExplorePage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/favoritos" element={<PortalHome />} />      {/* Placeholder */}
      <Route path="/instagram-callback" element={<InstagramCallbackPage />} />

      {/* Torneios */}
      <Route path="/torneios" element={<TournamentsListPage />} />
      <Route path="/torneios/:tournamentId" element={<TournamentDetailPage />} />
      <Route path="/torneios/etapa/:stageId" element={<StageDetailPage />} />

      {/* Wikipesca */}
      <Route path="/wikipesca/*" element={<WikiRouter />} />

      {/* Rota de Perfil Social (Catch-all: deve ser a última) */}
      <Route path="/:handle" element={<SocialProfilePublicPage />} />
    </Routes>
  );
};
